import _ from 'lodash';
import { getI18n } from 'react-i18next';

export const ERROR_INVALID_PRICE_VALUE = 'error.invalidPriceValue';
export const ERROR_DATABASE = 'error.database';
export const ERROR_AMQP_REDECLARE_EXCHANGES = 'error.amqp.declareBroadcastExchanges';
export const ERROR_FOUR_EYES_PRINCIPLE_CREDENTIALS_NEEDED = 'error.fourEyesPrinciple.credentialsNeeded';
export const ERROR_EXTRA_CONFIRMATION_NEEDED = 'error.extraConfirmationNeeded';
export const ERROR_FOUR_EYES_PRINCIPLE_DIFFERENT_USER_NEEDED = 'error.fourEyesPrinciple.differentUserNeeded';
export const ERROR_FOUR_EYES_PRINCIPLE_INVALID_AUTHENTICATION = 'error.fourEyesPrinciple.invalidAuthentication';
export const ERROR_FOUR_EYES_PRINCIPLE_INVALID_AUTHORIZATION = 'error.fourEyesPrinciple.invalidAuthorization';
export const ERROR_UNEXPECTED_ERROR = 'error.misc.unexpectedError';
export const ERROR_XML_PARSE_ERROR = 'error.xml.parseError';
export const ERROR_XML_FILE_ERROR = 'error.xml.fileError';
export const ERROR_INVALID_CELL_VALUE = 'error.misc.invalidCellValue';
export const ERROR_JSON_PROCESSING_ERROR = 'error.json.processingError';
export const ERROR_XLS_ERROR_READING_FILE = 'error.xls.errorReadingFile';
export const ERROR_XLS_NON_NUMERIC_VALUE = 'error.xls.nonNumericValue';
export const ERROR_XLS_INVALID_CELL_TYPE = 'error.xls.invalidCellType';
export const ERROR_XLS_NON_INTEGER_VALUE = 'error.xls.nonIntegerValue';
export const ERROR_XLS_EXPECTED_TEXT_NOT_FOUND = 'error.xls.expectedTextNotFound';
export const ERROR_READING_FILE = 'error.errorReadingFile';
export const ERROR_CSV_WRONG_SEPARATOR = 'error.csv.wrongSeparator';
export const ERROR_CSV_ERROR_READING_FILE = 'error.csv.errorReadingFile';
export const ERROR_CSV_EXPECTED_TEXT_NOT_FOUND = 'error.csv.expectedTextNotFound';
export const ERROR_CSV_NON_NUMERIC_VALUE = 'error.csv.nonNumericValue';
export const ERROR_CSV_NON_INTEGER_VALUE = 'error.csv.nonIntegerValue';
export const ERROR_INVALID_PARAMETER_TYPE = 'error.invalidParameterType';
export const ERROR_MISSING_PARAMETER = 'error.missingParameter';
export const ERROR_FILE_DOWNLOAD_SAMPLE_FILE_INVALID_COMBINATION = 'error.fileDownload.sampleFileInvalidTypeFormatCombination';

export const createMiscErrorMessage = (code, params) => { // NOSONAR javascript:S3800
    let result;
    const i18n = getI18n();
    switch (code) {
        case ERROR_INVALID_PRICE_VALUE:
            result = i18n.t('errors.invalid-price-value');
            break;
        case ERROR_DATABASE:
            result = i18n.t('errors.database');
            break;
        case ERROR_FILE_DOWNLOAD_SAMPLE_FILE_INVALID_COMBINATION:
            result = i18n.t('sample-files-download.invalid-type-format-combination', params);
            break;
        case ERROR_MISSING_PARAMETER:
            result = i18n.t('misc.error.missing-parameter', params);
            break;
        case ERROR_INVALID_PARAMETER_TYPE:
            result = i18n.t('misc.error.invalid-parameter-type', params);
            break;
        case ERROR_AMQP_REDECLARE_EXCHANGES:
            result = i18n.t('settings.amqp.redeclare-exchanges-error');
            break;
        case ERROR_FOUR_EYES_PRINCIPLE_DIFFERENT_USER_NEEDED:
            result = i18n.t('four-eyes-principle.error.different-user-needed');
            break;
        case ERROR_FOUR_EYES_PRINCIPLE_INVALID_AUTHENTICATION:
            result = i18n.t('four-eyes-principle.error.invalid-authentication');
            break;
        case ERROR_FOUR_EYES_PRINCIPLE_INVALID_AUTHORIZATION:
            result = i18n.t('four-eyes-principle.error.invalid-authorization');
            break;
        case ERROR_UNEXPECTED_ERROR:
            result = i18n.t('misc.error.unexpected-error');
            break;
        case ERROR_XML_FILE_ERROR:
            result = i18n.t('misc.error.xml.file-error');
            break;
        case ERROR_XML_PARSE_ERROR:
            result = i18n.t('misc.error.xml.parse-error', params);
            break;
        case ERROR_INVALID_CELL_VALUE:
            result = i18n.t('misc.error.invalid-cell-value', params);
            break;
        case ERROR_JSON_PROCESSING_ERROR:
            result = i18n.t('misc.error.json.processing-error');
            break;
        case ERROR_XLS_ERROR_READING_FILE:
            result = i18n.t('misc.error.xls.error-reading-file');
            break;
        case ERROR_XLS_NON_NUMERIC_VALUE:
            result = i18n.t('misc.error.xls.non-numeric-value', params);
            break;
        case ERROR_XLS_INVALID_CELL_TYPE:
            result = i18n.t('misc.error.xls.invalid-cell-type', params);
            break;
        case ERROR_XLS_NON_INTEGER_VALUE:
            result = i18n.t('misc.error.xls.non-integer-value', params);
            break;
        case ERROR_XLS_EXPECTED_TEXT_NOT_FOUND:
            result = i18n.t('misc.error.xls.expected-text-not-found', params);
            break;
        case ERROR_READING_FILE:
            result = i18n.t('misc.error.error-reading-file', params);
            break;
        case ERROR_CSV_ERROR_READING_FILE:
            result = i18n.t('misc.error.csv.error-reading-file', params);
            break;
        case ERROR_CSV_WRONG_SEPARATOR:
            result = i18n.t('misc.error.csv.wrong-separator', params);
            break;
        case ERROR_CSV_EXPECTED_TEXT_NOT_FOUND:
            result = i18n.t('misc.error.csv.expected-text-not-found', params);
            break;
        case ERROR_CSV_NON_NUMERIC_VALUE:
            result = i18n.t('misc.error.csv.non-numeric-value', params);
            break;
        case ERROR_CSV_NON_INTEGER_VALUE:
            result = i18n.t('misc.error.csv.non-integer-value', params);
            break;
        default:
            result = undefined;
    }
    return result;
};

const containsGraphQLError = (errorResponse, errorCode) => {
    let result = false;
    if (errorResponse) {
        const { graphQLErrors } = errorResponse;
        if (graphQLErrors && graphQLErrors.length > 0) {
            result = graphQLErrors.some((graphQLError) => graphQLError.extensions.errors.some((err) => err.code === errorCode));
        }
    }
    return result;
};

const containsRESTError = (errorResponseData, errorCode) => _.isArray(errorResponseData)
    && errorResponseData.some((errObject) => errObject.code === errorCode);

export const isFourEyesPrincipleNeeded = (error) => containsGraphQLError(error, ERROR_FOUR_EYES_PRINCIPLE_CREDENTIALS_NEEDED)
    || containsGraphQLError(error, ERROR_FOUR_EYES_PRINCIPLE_INVALID_AUTHENTICATION)
    || containsGraphQLError(error, ERROR_FOUR_EYES_PRINCIPLE_INVALID_AUTHORIZATION);

export const isExtraBackendConfirmationNeeded = (error) => containsGraphQLError(error, ERROR_EXTRA_CONFIRMATION_NEEDED) || containsRESTError(error, ERROR_EXTRA_CONFIRMATION_NEEDED);
